import * as React from "react";

// Canonical mobile breakpoint per CLAUDE.md (<1024px). The shadcn
// default of 768 didn't match the project convention and left a 256px
// tablet-portrait dead zone where shellFrame's isMobile (now also 1023)
// and isDesktopViewport disagreed. The hook returns true for any
// viewport with width ≤ 1023, i.e. phones AND iPad portrait.
const MOBILE_BREAKPOINT = 1024;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(
    undefined,
  );

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return !!isMobile;
}
